import { useAdminCargoCreatePageProps } from "./fetch";
import { AdminCargoCreatePageUi } from "./ui";

export const AdminCargoCreatePage: React.FC = () => {
  const props = useAdminCargoCreatePageProps();
  return <AdminCargoCreatePageUi {...props} />;
};
